import type { ValueOf } from 'cpool-utils';

export const CHAT_ENTRY_STATES = {
    ENABLED: 'enabled',
    ERROR: 'error',
    HIDDEN: 'hidden',
    LOADING: 'loading',
    NOT_ASSIGNED: 'notAssigned',
} as const;

export type ChatEntryState = ValueOf<typeof CHAT_ENTRY_STATES>;

// undefined = still loading, null = request failed; neither enables, so the entry doesn't flicker
export const resolveChatEntryState = ({
    hasChatAccess,
    hasExistingChats,
    hasPhoneNumber,
    isAdmin,
}: {
    hasChatAccess: boolean;
    hasExistingChats: boolean | null | undefined;
    hasPhoneNumber: boolean | null | undefined;
    isAdmin: boolean;
}): ChatEntryState => {
    if (!hasChatAccess) return CHAT_ENTRY_STATES.HIDDEN;
    if (isAdmin || hasPhoneNumber || hasExistingChats) return CHAT_ENTRY_STATES.ENABLED;
    if (hasPhoneNumber === undefined || hasExistingChats === undefined) return CHAT_ENTRY_STATES.LOADING;
    if (hasPhoneNumber === null || hasExistingChats === null) return CHAT_ENTRY_STATES.ERROR;
    return CHAT_ENTRY_STATES.HIDDEN;
};
